// Kategori ağacı aç/kapa durumu (kimlik kümesi) — ekran + kullanıcı başına localStorage'da kalıcı
// (`loadCollapsed` kalıbı; depolama kapalıysa yalnız oturum içi). `useTreeCollapsed` gösterge
// bantlarına bağlıdır; bu kanca ağacın kendi bant kimliklerini alır (Paketler üye ağacı).
import { useCallback, useEffect, useRef, useState } from "react";
import { loadCollapsed, saveCollapsed, toggleAllCollapsed } from "../lib/kpi-tree-list";
import { useAuthStore } from "../stores/auth-store";

export interface IdsCollapsedApi {
  collapsed: ReadonlySet<string>;
  set: (id: string, collapsed: boolean) => void;
  toggleAll: (bandIds: readonly string[]) => void;
}

/** `screen` null → kalıcı değil (oturum içi, hep açık başlar). */
export function useIdsCollapsed(screen: string | null): IdsCollapsedApi {
  const userId = useAuthStore((s) => s.user?.id) ?? "anon";
  const [collapsed, setCollapsed] = useState<ReadonlySet<string>>(() =>
    screen === null ? new Set<string>() : loadCollapsed(userId, screen),
  );
  // auth sonradan hidrate olursa ("anon" → gerçek kimlik) kalıcı durumu yeniden yükle
  const loadedFor = useRef(`${userId}|${screen}`);
  useEffect(() => {
    const key = `${userId}|${screen}`;
    if (screen === null || loadedFor.current === key) return;
    loadedFor.current = key;
    setCollapsed(loadCollapsed(userId, screen));
  }, [userId, screen]);
  const commit = useCallback(
    (next: ReadonlySet<string>) => {
      setCollapsed(next);
      if (screen !== null) saveCollapsed(userId, screen, next);
    },
    [userId, screen],
  );
  return {
    collapsed,
    set: (id, c) => {
      if (collapsed.has(id) === c) return;
      const next = new Set(collapsed);
      if (c) next.add(id);
      else next.delete(id);
      commit(next);
    },
    toggleAll: (ids) => commit(toggleAllCollapsed(ids, collapsed)),
  };
}
